var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 290,
    viewBox: "0 0 200 290",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100 145)",
    id: "IfxJ8yCnMCnHKXDo6NYTy"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 1 0 0 0)",
    id: "6xBCQgywCCEikyQwTLMUX"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.87 -1.5 0 0 0)",
    id: "JMjLJn7qNmasgcD43jHR_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(81,105,211)",
      strokeWidth: 7,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,251,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -84.66368 -71.05538 C -84.66368 -78.57104 -74.14412 -84.66368 -61.167590000000004 -84.66368 L 59.971779999999995 -84.66368 L 59.971779999999995 -84.66368 C 73.60874 -84.66368 84.66368 -78.26096 84.66368 -70.36279 L 84.66368 70.23349 L 84.66368 70.23349 C 84.66368 78.20306000000001 73.50878 84.66368 59.74852 84.66368 L -59.74852 84.66368 L -59.74852 84.66368 C -73.50878 84.66368 -84.66368 78.20306 -84.66368 70.23349 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -0.25 0 118.84 0)",
    id: "cgVAm4Gq57vylcu0s6Qr0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,130,123)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,105,211)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -31.5695 -21.48224 C -31.5695 -27.05328 -30.64366 -31.5695 -29.50157 -31.5695 L 29.14109 -31.5695 L 29.14109 -31.5695 C 30.48227 -31.5695 31.569509999999998 -26.265990000000002 31.569509999999998 -19.72379 L 31.569509999999998 0.5724699999999991 L 31.569509999999998 0.5724699999999991 C 31.569509999999998 17.69166 28.7245 31.569499999999998 25.214999999999996 31.569499999999998 L -25.21499 31.569499999999998 L -25.21499 31.569499999999998 C -28.72449 31.569499999999998 -31.5695 17.69166 -31.5695 0.5724699999999991 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -0.25 0 118.84 0)",
    id: "SLZmut1RQDNFokkPjxkiB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,130,123)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,105,211)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -31.5695 -21.48224 C -31.5695 -27.05328 -30.64366 -31.5695 -29.50157 -31.5695 L 29.14109 -31.5695 L 29.14109 -31.5695 C 30.48227 -31.5695 31.569509999999998 -26.265990000000002 31.569509999999998 -19.72379 L 31.569509999999998 0.5724699999999991 L 31.569509999999998 0.5724699999999991 C 31.569509999999998 17.69166 28.7245 31.569499999999998 25.214999999999996 31.569499999999998 L -25.21499 31.569499999999998 L -25.21499 31.569499999999998 C -28.72449 31.569499999999998 -31.5695 17.69166 -31.5695 0.5724699999999991 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -0.25 0 118.84 0)",
    id: "pQ-s_AEB-pVZiOeKbwEgl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,130,123)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,105,211)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -31.5695 -21.48224 C -31.5695 -27.05328 -30.64366 -31.5695 -29.50157 -31.5695 L 29.14109 -31.5695 L 29.14109 -31.5695 C 30.48227 -31.5695 31.569509999999998 -26.265990000000002 31.569509999999998 -19.72379 L 31.569509999999998 0.5724699999999991 L 31.569509999999998 0.5724699999999991 C 31.569509999999998 17.69166 28.7245 31.569499999999998 25.214999999999996 31.569499999999998 L -25.21499 31.569499999999998 L -25.21499 31.569499999999998 C -28.72449 31.569499999999998 -31.5695 17.69166 -31.5695 0.5724699999999991 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -0.25 0 118.84 0)",
    id: "NtZKZ_Shy-CaO0PdwmGck"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,130,123)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,105,211)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -31.5695 -21.48224 C -31.5695 -27.05328 -30.64366 -31.5695 -29.50157 -31.5695 L 29.14109 -31.5695 L 29.14109 -31.5695 C 30.48227 -31.5695 31.569509999999998 -26.265990000000002 31.569509999999998 -19.72379 L 31.569509999999998 0.5724699999999991 L 31.569509999999998 0.5724699999999991 C 31.569509999999998 17.69166 28.7245 31.569499999999998 25.214999999999996 31.569499999999998 L -25.21499 31.569499999999998 L -25.21499 31.569499999999998 C -28.72449 31.569499999999998 -31.5695 17.69166 -31.5695 0.5724699999999991 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -0.25 0 118.84 0)",
    id: "VTKTsqbtR0H9NCDzDCvJa"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,130,123)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,105,211)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -31.5695 -21.48224 C -31.5695 -27.05328 -30.64366 -31.5695 -29.50157 -31.5695 L 29.14109 -31.5695 L 29.14109 -31.5695 C 30.48227 -31.5695 31.569509999999998 -26.265990000000002 31.569509999999998 -19.72379 L 31.569509999999998 0.5724699999999991 L 31.569509999999998 0.5724699999999991 C 31.569509999999998 17.69166 28.7245 31.569499999999998 25.214999999999996 31.569499999999998 L -25.21499 31.569499999999998 L -25.21499 31.569499999999998 C -28.72449 31.569499999999998 -31.5695 17.69166 -31.5695 0.5724699999999991 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.19 0 0 0.19 0 -10.73)",
    id: "_klx6CMV6B1ZLZ-YK3kSq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.77 0 0 0.92 -0.05 -49.78)",
    id: "BtXJH-nxPvTYU08cTC-jO"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(179,179,179)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -36.20689 -20.84561 C -36.20689 -24.91968 -35.98691 -28.826880000000003 -35.59535 -31.70768 C -35.20378 -34.58848 -34.67271 -36.2069 -34.118950000000005 -36.2069 L 34.11894999999999 -36.2069 L 34.11894999999999 -36.2069 C 34.67270999999999 -36.2069 35.20377999999999 -34.58848 35.59534999999999 -31.707679999999996 C 35.98691999999999 -28.826879999999996 36.20688999999999 -24.919679999999996 36.20688999999999 -20.845609999999997 L 36.20688999999999 20.8456 L 36.20688999999999 20.8456 C 36.20688999999999 29.3294 35.272089999999984 36.20689 34.118949999999984 36.20689 L -34.11895000000001 36.20689 L -34.11895000000001 36.20689 C -35.27209000000001 36.20689 -36.206890000000016 29.329410000000003 -36.206890000000016 20.8456 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.77 0 0 0.92 0.05 49.78)",
    id: "We0OBKUlbTiKAP3JiMHsp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(179,179,179)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -36.20689 -20.84561 C -36.20689 -24.91968 -35.98691 -28.826880000000003 -35.59535 -31.70768 C -35.20378 -34.58848 -34.67271 -36.2069 -34.118950000000005 -36.2069 L 34.11894999999999 -36.2069 L 34.11894999999999 -36.2069 C 34.67270999999999 -36.2069 35.20377999999999 -34.58848 35.59534999999999 -31.707679999999996 C 35.98691999999999 -28.826879999999996 36.20688999999999 -24.919679999999996 36.20688999999999 -20.845609999999997 L 36.20688999999999 20.8456 L 36.20688999999999 20.8456 C 36.20688999999999 29.3294 35.272089999999984 36.20689 34.118949999999984 36.20689 L -34.11895000000001 36.20689 L -34.11895000000001 36.20689 C -35.27209000000001 36.20689 -36.206890000000016 29.329410000000003 -36.206890000000016 20.8456 z",
    strokeLinecap: "round"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.0abd95d15246529b00e4d18b173043c8.svg";
export { ForwardRef as ReactComponent };